<script setup>
// eslint-disable-next-line no-undef
const props = defineProps({
    label: String,
    type: {
        type: String,
        default: 'button',
    },
    bgClass: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <button :type="props.type" :class="[props.bgClass]">
        {{ props.label }}
    </button>
</template>

<style scoped>
button {
    @apply !tw-text-[1.6em] tw-bg-primary tw-text-white !tw-font-semibold !tw-py-2 !tw-px-12 tw-rounded-[18px] tw-mb-[8px] tw-relative tw-overflow-hidden tw-cursor-pointer;
    box-shadow: -8px 8px 0 0 #FF50644D;
}

button:active {
    transform: translate(2px, 2px);
    box-shadow: -4px 4px 0 0 #FF50644D;
}

/* Light streak */
button::before {
    content: '';
    @apply tw-absolute tw-top-0 -tw-left-[75%] tw-w-1/2 tw-h-full;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 80%);
    transform: skewX(-20deg);
}

/* Animate streak on hover */
button:hover::before {
    animation: shine 0.75s forwards;
}

/* Keyframes for the streak animation */
@keyframes shine {
    0% {
        left: -75%;
    }
    100% {
        left: 125%;
    }
}
</style>
